export enum OutputType {
    footerHtml = 'footerHtml',
    headerHtml = 'headerHtml',
    html = 'html',
    json = 'json',
}
